import logo from './logo.svg';
// import './App.css';
import styles from "./App.module.css";
import Navbar from "./components/navbar";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Main from "./pages/main";
import Skills from "./pages/skills";
import Projects from "./pages/projects";
import Artworks from "./pages/artworks";
import Contacts from "./pages/contacts";

function App() {
  return (
    <div className={styles.appContainer}>
      <Router>
        <div className={styles.navContainer}>
          <Navbar />
        </div>
        <div className={styles.bodyContainer}>
          <section id="main">
            <Main />
          </section>
          <section id="skills">
            <Skills />
          </section>
          <section id="projects">
            <Projects />
          </section>
          <section id="artworks">
            <Artworks />
          </section>
          <section id="contacts">
            <Contacts />
          </section>
        </div>
      </Router>
    </div>
  );
}

export default App;
